import { Component } from '@angular/core';
import { LinksService } from '../../shared/services/links.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  constructor(private readonly linkService: LinksService) {}
  public async download(event, fileName: string): Promise<void> {
    event.preventDefault();
    return this.linkService.downloadDocument(fileName);
  }
}
